__webpack_require__.p = "/ototo/battlegame/movie/";